const STEPS = [
    {
        num: 1,
        color: '#ED5C2F',
        title: 'Strategy call',
        desc: '20 minutes. We review your buy box, markets, current mail, deal goals, and monthly budget.',
    },
    {
        num: 2,
        color: '#F28230',
        title: 'List + offer',
        desc: 'We build the right list - triggers, stacked motivation signals, or both - and pair it with the offer and format that fits the campaign.',
    },
    {
        num: 3,
        color: '#FAB331',
        title: 'Produce + mail',
        desc: 'Our in-house print and mail operation keeps drops moving - including 2-business-day production when speed matters most.',
    },
    {
        num: 4,
        color: '#3F454F',
        title: 'Track + improve',
        desc: 'Use call tracking, QR codes, delivery confirmation, and reporting to compare lists, offers, and creative drop over drop.',
    },
]

export default function HowItWorks() {
    return (
        <section className="bg-[#FFF7EC]">
            <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8 lg:py-16">
                <div className="mb-10 flex max-w-3xl flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-secondary">
                        How it works
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-[#3F454F] md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Launch a campaign
                    </h2>
                    <h2
                        className="-mt-3 bg-clip-text pb-1 text-3xl font-bold tracking-tight text-transparent md:text-[44px]"
                        style={{
                            lineHeight: 1.05,
                            backgroundImage:
                                'linear-gradient(to right, #ED5C2F 10%, #F28230 35%, #FAB331 65%)',
                        }}>
                        without guessing where to mail next.
                    </h2>
                    <p
                        className="text-lg text-[#3F454F]/70"
                        style={{ lineHeight: '28px' }}>
                        We start with your buy box, markets, and deal goals.
                        Then we build the audience, offer, creative, production
                        plan, and tracking around the deals you actually want
                        more of.
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-5 lg:grid-cols-4">
                    {STEPS.map((step) => (
                        <div
                            key={step.num}
                            className="group flex flex-col gap-3 rounded-2xl border border-gray-200/50 bg-white p-7 transition-all duration-300 ease-out hover:-translate-y-1 hover:border-secondary/30 hover:shadow-lg">
                            <div
                                className="flex h-9 w-9 items-center justify-center rounded-lg transition-transform duration-300 ease-out group-hover:scale-110"
                                style={{ backgroundColor: step.color }}>
                                <span className="font-bold text-white">
                                    {step.num}
                                </span>
                            </div>
                            <h3
                                className="text-xl font-bold text-[#3F454F] md:text-[25px]"
                                style={{ lineHeight: '28px' }}>
                                {step.title}
                            </h3>
                            <p className="text-sm text-[#3F454F]/65">
                                {step.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
